import { createSlice, current } from '@reduxjs/toolkit'

const userList = createSlice({
    name: 'userList',//Данные по компаниям
    initialState: {
        list: [],
        list_loaded: false,
    },
    reducers: {
        loadList(state, action) {
            const id_status = action.payload.id_status;
            state.list = action.payload.data.sort((a, b) => a.Name_User.localeCompare(b.Name_User));
            state.list_loaded = true;
        },
        update(state, action) {
            const model = action.payload.model;
            state.list = [...state.list.filter(a => a.ID_User !== model.ID_User), model].sort((a, b) => a.Name_User.localeCompare(b.Name_User));
        },
        remove(state, action) {
            const id = action.payload.id;
            state.list = state.list.filter(a => a.ID_User !== id);
        }
    }
})

export const { loadList, remove, update } = userList.actions
export default userList.reducer